<template>
  <component
    :class="[ headingClass, weightClass ]"
    class="smart__title user-select-none"
    :is="headingTag"
  >
    <slot />
  </component>
</template>


<script>
// @flow
export default {
  name: 'SmartTitle',
  props: {
    heading: {
      type: String,
      default: '2',
      validator(value: string): boolean {
        return ['1', '2', '3', '4'].includes(value);
      }
    },
    weight: {
      type: String,
      default: 'bold',
      validator(value: string): boolean {
        return ['bold', 'medium', 'regular'].includes(value);
      }
    }
  },
  computed: {
    headingTag() {
      return `h${this.heading}`;
    },
    headingClass() {
      return `smart__title--${this.headingTag}`;
    },
    weightClass() {
      switch (this.weight) {
      case 'regular':
        return 'font-normal';
      case 'medium':
        return 'font-medium';
      case 'bold':
        return 'font-bold';
      default:
        return 'font-bold';
      }
    }
  }
};
</script>

<style lang="scss">
.smart__title {
  font-family: $font-family-01;
  line-height: normal;
  letter-spacing: -0.02em;
  &--h1 {
    font-size: $font-size-h1;
    margin-left: 1rem;
    margin-right: 1rem;
  }
  &--h2 {
    font-size: $font-size-h2;
  }
}
</style>
